export const iconFontAwesomeAstronomyMeteor = (
	<i className="fa-solid fa-meteor"></i>
);
